import React from "react";
import type { InfoFieldProps } from "./FormFields.interface";

export const InfoField: React.FC<InfoFieldProps> = ({ label, value }) => {
  return (
    <div className="info-field">
      <label>
        <strong>{label ? `${label}: ` : ""}</strong>
      </label>
      <div className="info-field-value">{value ?? ""}</div>
    </div>
  );
};
